import React, { useState } from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { Heading, IconArrowHead, PropertyGroup } from '../../components';

import css from './ListingPage.module.css';

const SectionExperienceInvolves = props => {
  const { publicData, locale, listingFieldConfigs } = props;
  const { Thisexperienceinvolves } = publicData;


  if (!Thisexperienceinvolves) {
    return null;
  }

  const [showSection, setShowSection] = useState(true);


  const options = listingFieldConfigs?.find(c => c.key === "Thisexperienceinvolves")
    ?.enumOptions?.map(o => ({ key: o.option, label: o.label }));
  const selectedOptions = Thisexperienceinvolves;

  return (
    <section className={css.section}>
      <Heading as="h2" rootClassName={css.sectionTitle} onClick={() => setShowSection(!showSection)}>
        <FormattedMessage id="ListingPage.experienceInvolves" />
        <IconArrowHead direction={showSection ? "up" : "down"} />
      </Heading>

      {showSection && (
        <PropertyGroup
          key="ListingPage.experienceInvolves"
          id="ListingPage.experienceInvolves"
          options={options}
          selectedOptions={selectedOptions}
          twoColumns={options.length > 5}
          showUnselectedOptions={false}
          useTranslations
          className={css.propertyGroupList}
        />
      )}

    </section>
  );
};

export default SectionExperienceInvolves;
